// extracted by mini-css-extract-plugin
module.exports = {"search-button":"SearchButton_search-button__9tQuM","--theme-white":"SearchButton__--theme-white__QqR4L"};